import { useState } from "react";
import { Box, FormControlLabel, Radio, RadioGroup, Stack, Switch, useTheme } from "@mui/material";
import Text from "../../../_components/Text";
import CustomPaper from "../../../_components/CustomPaper";
import RadioUnchecked from "../../../_components/icons/RadioUnchecked";
import RadioChecked from "../../../_components/icons/RadioChecked";

function getLastDayOfMonth(next?: boolean): string {
  const date = new Date();

  if (next) {
    date.setMonth(date.getMonth() + 1);
  }

  date.setDate(0);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
}

const InsuranceDuration = () => {
  const theme = useTheme();

  const [durationValue, setDurationValue] = useState<string>("0");
  const handleChange = (value: string) => setDurationValue(value);

  return (
    <CustomPaper
      label="Insurance duration"
      labelVariant="regular"
      color={theme.myTheme.colors.gray500}
    >
      <Stack
        paddingTop={1}
        direction="column"
        sx={{ width: "100%" }}
        justifyContent={"space-between"}
        spacing={1}
      >
        <Box>
          <Text variant="s" color={theme.myTheme.colors.foreground50}>
            Decide how long you want your insurance to last. The longer the coverage, the higher the
            cost
          </Text>
        </Box>
        <RadioGroup value={durationValue} onChange={(e) => handleChange(e.target.value)}>
          <FormControlLabel
            value="0"
            control={
              <Radio
                icon={<RadioUnchecked size={20} colorCustom={theme.myTheme.colors.foreground100} />}
                checkedIcon={
                  <RadioChecked size={20} colorCustom={theme.myTheme.colors.foreground100} />
                }
              />
            }
            label={
              <Text variant="regular" color={theme.myTheme.colors.foreground50}>
                Till the end of this month{" "}
                <span style={{ color: theme.myTheme.colors.foreground100 }}>
                  ({getLastDayOfMonth()})
                </span>
              </Text>
            }
          />
          <FormControlLabel
            value="1"
            control={
              <Radio
                icon={<RadioUnchecked size={20} colorCustom={theme.myTheme.colors.foreground100} />}
                checkedIcon={
                  <RadioChecked size={20} colorCustom={theme.myTheme.colors.foreground100} />
                }
              />
            }
            label={
              <Text variant="regular" color={theme.myTheme.colors.foreground50}>
                Till the end of next month{" "}
                <span style={{ color: theme.myTheme.colors.foreground100 }}>
                  ({getLastDayOfMonth(true)})
                </span>
              </Text>
            }
          />
        </RadioGroup>
      </Stack>
    </CustomPaper>
  );
};

export default InsuranceDuration;
